import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const CityThemeContext = createContext(null);

/** Cidade em exibição (modo apresentação). Definida pelo Admin Time Food. */
export const CityThemeProvider = ({ children }) => {
  const [cities, setCities] = useState([]);
  const [cityId, setCityId] = useState(() => localStorage.getItem("tf_city") || "");

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/cities");
      setCities(data);
      if (!localStorage.getItem("tf_city") && data.length) {
        const mage = data.find((c) => c.name === "Magé") || data[0];
        setCityId(mage.id);
      }
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  const setCity = (id) => {
    localStorage.setItem("tf_city", id);
    setCityId(id);
  };

  const city = cities.find((c) => c.id === cityId) || cities.find((c) => c.name === "Magé") || null;

  return (
    <CityThemeContext.Provider
      value={{
        cities, city, cityId: city?.id || "", setCity, reloadCities: load,
        cityName: city?.name || "Magé",
        brandName: city?.brand_name || "Magé Time Food",
        accent: city?.accent_color || "#1F3864",
      }}
    >
      {children}
    </CityThemeContext.Provider>
  );
};

export const useCityTheme = () => useContext(CityThemeContext);
